module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("tslib");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("@cian/text-field-component");

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(3), exports);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var text_field_component_1 = __webpack_require__(1);
var React = __webpack_require__(4);
var styles = __webpack_require__(5);
var text_field_component_2 = __webpack_require__(1);
exports.VisualSize = text_field_component_2.VisualSize;
var PasswordField = /** @class */ (function (_super) {
    tslib_1.__extends(PasswordField, _super);
    function PasswordField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isHidden: true,
        };
        return _this;
    }
    PasswordField.prototype.focus = function () {
        this.textField.focus();
    };
    PasswordField.prototype.blur = function () {
        this.textField.blur();
    };
    PasswordField.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: styles['container'] },
            React.createElement(text_field_component_1.TextField, tslib_1.__assign({}, this.props, { type: this.state.isHidden ? 'password' : 'text', ref: function (textField) { return _this.textField = textField; } })),
            React.createElement("button", { className: styles['eye'], type: "button", onClick: function () { return _this.setState({ isHidden: !_this.state.isHidden }); } }, this.state.isHidden ? renderEyeClosed() : renderEyeOpened())));
    };
    PasswordField.defaultProps = {
        size: text_field_component_1.VisualSize.SMALL,
    };
    return PasswordField;
}(React.Component));
exports.PasswordField = PasswordField;
function renderEyeClosed() {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18 18", width: "18", height: "18" },
        React.createElement("path", { d: "M18 9.6l-1.7-1.1S14 12 9 12 1.8 8.7 1.7 8.5L.8 9l-.8.6c0 .1.5.8 1.5 1.6l-.8 1.2 1.6 1.2.8-1.2c.4.2.8.5 1.3.7l-.6 1.7 1.9.7.7-1.8c.5.1 1.1.2 1.7.3v1.7h2V14c.6 0 1.1-.1 1.7-.3l.7 1.8 1.9-.7-.8-1.8c.5-.2.9-.4 1.3-.7l.8 1.2 1.6-1.2-.8-1.2c1-.8 1.5-1.5 1.5-1.5z", fill: "#7a7a7a" })));
}
function renderEyeOpened() {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18 18", width: "18", height: "18" },
        React.createElement("path", { d: "M9 4C3.1 4 .5 8.3.3 8.5L0 9l.3.5C.5 9.7 3.1 14 9 14s8.5-4.3 8.7-4.5L18 9l-.3-.5C17.5 8.3 14.9 4 9 4zm0 6.7c-1 0-1.8-.8-1.8-1.7S8 7.3 9 7.3s1.8.8 1.8 1.7-.8 1.7-1.8 1.7zM2.4 9c.6-.7 1.9-1.9 3.8-2.6-.6.7-1 1.6-1 2.6s.4 1.9 1.1 2.6C4.3 10.9 3 9.7 2.4 9zm9.4 2.6c.7-.7 1.1-1.6 1.1-2.6s-.4-1.9-1.1-2.6c2 .6 3.2 1.9 3.8 2.6-.6.7-1.9 1.9-3.8 2.6z", fill: "#7a7a7a" })));
}


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"password_field_component-container-50O9qVtQrSO","eye":"password_field_component-eye-cLvGPMZpaSo"};

/***/ })
/******/ ]);
//# sourceMappingURL=frontend-password-field-component.js.map